// 출입문 목록 응답의 lastKeepOpenChange(관리자앱에서 마지막으로 성공한 상시 문열기 ON/OFF)를 한 줄 안내로 만든다.
// 센터가 "누가 언제 켰는지"를 고객센터 문의 없이 바로 확인하게 하려는 문구다.

export type KeepOpenChange = {
  action: "ON" | "OFF";
  changedAt: string; // yyyy-MM-dd'T'HH:mm:ss (서버 로컬 시각)
  managerName: string | null;
  deviceModel: string | null;
};

const ACTION_TEXT: Record<KeepOpenChange["action"], string> = {
  ON: "켰어요",
  OFF: "해제했어요",
};

// 서버가 준 로컬 시각 문자열을 그대로 읽는다(Date 변환 시 기기 타임존에 따라 시각이 밀릴 수 있다).
export const formatChangedAt = (changedAt: string, currentYear: number = new Date().getFullYear()) => {
  const [datePart, timePart = ""] = changedAt.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const time = timePart.slice(0, 5);
  const date = year === currentYear ? `${month}/${day}` : `${year}/${month}/${day}`;
  return time ? `${date} ${time}` : date;
};

// 사람 표기: 직원명(기종) / 직원명 / 기종 / 없음
export const formatActorName = (managerName: string | null, deviceModel: string | null) => {
  if (managerName && deviceModel) return `${managerName}(${deviceModel})`;
  if (managerName) return managerName;
  if (deviceModel) return deviceModel;
  return null;
};

const formatActor = (managerName: string | null, deviceModel: string | null) => {
  if (managerName && deviceModel) return `${managerName}(${deviceModel})님이`;
  if (managerName) return `${managerName}님이`;
  if (deviceModel) return `${deviceModel} 기기에서`;
  return null;
};

export const formatKeepOpenChange = (
  change: KeepOpenChange | null | undefined,
  currentYear: number = new Date().getFullYear()
) => {
  if (!change || !change.changedAt || !ACTION_TEXT[change.action]) return null;

  const actor = formatActor(change.managerName, change.deviceModel);
  const parts = [formatChangedAt(change.changedAt, currentYear), actor, `상시 문열기를 ${ACTION_TEXT[change.action]}`];
  return parts.filter(Boolean).join(" ");
};
